<template>
  <div class="archive-project-evidence" :class="`evidence-${detail}`">
    <ExhibitionTicket v-if="detail === 'ticket'" :view="ticketSample" sample />
    <GalleryFilm v-else-if="detail === 'film'" />
    <GalleryDesignStudy v-else-if="detail === 'gallery'" />
    <GalleryExperienceStudy v-else-if="detail === 'exhibition'" :groups="['exhibition', 'atmosphere']" />
    <ProjectShowcase v-else-if="detail === 'illustration'" project-id="searchstory" :scene="scene" contextual />
  </div>
</template>
<script>
import ExhibitionTicket from './ExhibitionTicket.vue';
import GalleryDesignStudy from '../ui/GalleryDesignStudy.vue';
import GalleryExperienceStudy from '../ui/GalleryExperienceStudy.vue';
import ProjectShowcase from '../ui/ProjectShowcase.vue';
import GalleryFilm from '../ui/GalleryFilm.vue';
import ticketSample from '../../data/projectTicketSample.json';
export default {
  components: { ExhibitionTicket, GalleryDesignStudy, GalleryExperienceStudy, ProjectShowcase, GalleryFilm },
  props: { detail: { type: String, required: true }, scene: { type: String, default: '' } },
  data: () => ({ ticketSample }),
};
</script>
<style scoped>
.archive-project-evidence { --case-ink: #333330; --case-muted: #77756f; --case-rule: rgb(76 70 56 / 16%); --case-nav-bg: #faf9f7; min-width: 0; width: 100%; color: var(--case-ink); }
body.dark-mode .archive-project-evidence { --case-ink: #ddd9d1; --case-muted: #aaa69e; --case-rule: rgb(255 255 255 / 16%); --case-nav-bg: #242424; }
.evidence-ticket { padding: 28px 12px; box-sizing: border-box; }
.evidence-exhibition :deep(.gallery-experience-study) { margin-top: 0; }
.evidence-illustration :deep(.project-showcase) { margin: 0; }
</style>
